import { ILaya } from "../../ILaya";
import { Loader } from "../net/Loader";
export class ExternalSkin {
    constructor() {
        this.normal = false;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
        if (value) {
            ILaya.loader.load(value, Loader.SPINE).then((templet) => {
                if (!this._source || templet && !templet.isCreateFromURL(this._source))
                    return;
                this.templet = templet;
            });
        }
        else
            this.templet = null;
    }
    get items() {
        return this._items;
    }
    set items(value) {
        this._items = value;
    }
    get templet() {
        return this._templet;
    }
    set templet(value) {
        this.init(value);
    }
    init(templet) {
        this._templet = templet;
        if (!this._templet) {
            return;
        }
        this.flush();
    }
    flush() {
        var _a, _b, _c;
        let targetTemplet = (_a = this.target) === null || _a === void 0 ? void 0 : _a.templet;
        let skeletonData = (_b = this._templet) === null || _b === void 0 ? void 0 : _b.skeletonData;
        if (this._items && skeletonData
            && targetTemplet
            && targetTemplet._textures) {
            for (let i = this._items.length - 1; i >= 0; i--) {
                let o = this._items[i];
                let attachmentStr = o.attachment;
                let slot = o.slot;
                let skinStr = o.skin;
                if (attachmentStr && slot && skinStr) {
                    let attachment = null;
                    let skins = skeletonData.skins;
                    for (let j = skins.length - 1; j >= 0; j--) {
                        if (skins[j].name == skinStr) {
                            let skin = skins[j];
                            let attachments = skin.attachments;
                            for (let j = attachments.length - 1; j >= 0; j--) {
                                attachment = (_c = attachments[j]) === null || _c === void 0 ? void 0 : _c[attachmentStr];
                                if (attachment) {
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    if (attachment) {
                        let regionPage = attachment.region.page;
                        targetTemplet.setTexture(regionPage.name, regionPage.texture.realTexture);
                        let slotObj = this.target.getSkeleton().findSlot(slot);
                        if (slotObj) {
                            slotObj.setAttachment(attachment);
                        }
                    }
                }
            }
            this.normal = this._templet !== targetTemplet;
        }
        else {
            this.normal = false;
        }
    }
}
